export const SERVER_SETTINGS_SUBPATH = "server-settings";
